import { Autocomplete, Button, MenuItem, TextField } from '@mui/material'
import { useEffect, useState } from 'react'
import ResourceSelectDialog from '../Common/ResourceSelectDialog';
import HouseList from '../Houses/HouseList';
import TransactionButton from '../Common/TransactionButton';
import { setCustomSelectOpen } from '../../store/reducers/customSelect';
import { useAppDispatch } from '../../store/hooks';
import moment from 'moment';
import { ShortTimeEnum } from '../../enums/ShortTimeEnum';
import CityResponse from '../../interfaces/City/CityResponse';
import CityService from '../../services/CityService';
import AreaService from '../../services/AreaService';
import EventBus from '../../EventBus';
import { EventBusEventsEnum } from '../../enums/EventBusEventsEnum';
import { CustomSnackbarTypes } from '../Common/CustomSnackBar';
import ComboService from '../../services/ComboService';
import ComboDiscountTable from './ComboDiscountTable';
import EmptyListPlaceholder from '../Common/EmptyListPlaceholder';
import CircularLoader from '../Common/CircularLoader';

//Common styles
import {
    FilterContainer,
    FilterTextField,
    FilterWrapper,
    WorkspaceContainer,
} from '../../styles/commonStyles';

let cityService = new CityService();
let areaService = new AreaService();
let comboService = new ComboService();

function ComboDiscountCalculator() {
    const [openHouseDialog, setOpenHouseDialog] = useState(false);
    const [houseId, setHouseId] = useState<any>(null);
    const [time, setTime] = useState<any>(null);
    const [cityList, setCityList] = useState<CityResponse[]>([]);
    const [selectCity, setSelectCity] = useState<any>(null);
    const [selectAreaId, setSelectAreaId] = useState<number | null>(null);
    const [areaList, setAreaList] = useState<any>([]);
    const [selectedArea, setSelectArea] = useState<any>(null)
    const [discountData, setDiscountData] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(false);


    useEffect(() => {
        cityService.fetchAllCities(1000, 0, { isCurrentlyServing: "YES" }, {}).then((res) => {
          setCityList(res?.data);
        });
    }, [])
    useEffect(() => {
        const filters: Record<string, number | string> = {};
        setAreaList([]);
        setSelectAreaId(null);
        setSelectArea(null);
        if (selectCity) {
          filters.cityId = selectCity;
        }
        areaService.fetchAllAreas(1000, 0, filters, { "field": "name", "order": "ASC" }).then((res) => {
            setAreaList(res?.data);
        })
    }, [selectCity])
    useEffect(() => {
        setDiscountData(null);
    },[selectAreaId, houseId, time, selectCity])

    const dispatch = useAppDispatch();

    const handleCloseHouse = (record: any) => {
        setOpenHouseDialog(false);
        setHouseId(record?.id);
    };

    const handleSelectHouse = () => {
        setOpenHouseDialog(true);
        dispatch(
            setCustomSelectOpen({
                open: true,
            })
        );
    };
    let calculateDiscount = async() => {
        if(selectAreaId || houseId){
            setLoading(true);
            let payload = {}
            if (houseId) {
                payload = {
                    houseId: houseId,
                    date: moment(new Date()).format("YYYY-MM-DD"),
                    time: time,
                    numberOfDays: 7
                }
            }
            else{
                payload = {
                    areaId: selectAreaId,
                    date: moment(new Date()).format("YYYY-MM-DD"),
                    time: time,
                    numberOfDays: 7
                }
            }
            try {
                let data = await comboService.calculateComboDiscount(payload);
                setDiscountData(data);
                setLoading(false)
            } catch (error) {
                setLoading(false)
            }
        }
        else{
            EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                message: 'Select Either houseId or areaId',
                type: CustomSnackbarTypes.ERROR
            })
            return;
        }
    }
  return (
    <WorkspaceContainer>
        {openHouseDialog && (
            <ResourceSelectDialog
                name={"Houses"}
                list={HouseList}
                onClose={handleCloseHouse}
            />
        )}

        {/* ── Inputs — filter-style box, no heading ── */}
        <FilterWrapper>
            <FilterContainer
                style={{ flexWrap: "wrap", rowGap: "12px", padding: "16px 20px" }}
            >
                <TransactionButton
                    name={houseId ? `House Id: ${houseId}` : "Choose House"}
                    onClickHandler={() => handleSelectHouse()}
                />

                <FilterTextField
                    select
                    label="Time"
                    size="small"
                    variant="outlined"
                    value={time ?? ""}
                    onChange={(event: any) => {
                        setTime(event.target.value);
                    }}
                    sx={{ minWidth: 180 }}
                >
                    {Object.values(ShortTimeEnum).map((e) => (
                        <MenuItem key={e} value={e}>
                            {e}
                        </MenuItem>
                    ))}
                </FilterTextField>

                {!houseId && (
                    <FilterTextField
                        select
                        label="City"
                        size="small"
                        variant="outlined"
                        value={selectCity ?? ""}
                        onChange={(event) => {
                            let value: any = event.target.value;
                            setSelectCity(value);
                        }}
                        sx={{ minWidth: 160 }}
                    >
                        {cityList.map((eachCity) => (
                            <MenuItem key={eachCity?.name} value={eachCity?.id}>
                                {eachCity?.name}
                            </MenuItem>
                        ))}
                    </FilterTextField>
                )}

                {selectCity && (
                    <Autocomplete
                        id="select-Area-select"
                        options={areaList?.map((each: { id: number; name: string }) => {
                            return { label: each?.name, value: each?.id };
                        })}
                        onChange={(_, data: any) => {
                            setSelectAreaId(data?.value);
                            setSelectArea(data);
                        }}
                        value={selectedArea}
                        sx={{ minWidth: 200 }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Area"
                                size="small"
                                variant="outlined"
                                // Mirrors FilterTextField (the Time / City look)
                                // on a plain TextField so the Autocomplete popup
                                // keeps working
                                sx={{
                                    "& .MuiFormHelperText-root": {
                                        display: "none",
                                    },
                                    "& .MuiOutlinedInput-root": {
                                        borderRadius: "8px",
                                        backgroundColor: "rgb(249, 250, 251)",
                                        paddingLeft: "12px",
                                        paddingRight: "12px",
                                        "& fieldset": {
                                            borderColor: "rgb(225, 231, 239)",
                                        },
                                        "&:hover fieldset": {
                                            borderColor: "rgb(225, 231, 239)",
                                        },
                                        "&.Mui-focused fieldset": {
                                            borderColor: "rgb(225, 231, 239)",
                                            borderWidth: "1px",
                                        },
                                    },
                                }}
                            />
                        )}
                    />
                )}

                {(houseId || selectAreaId) && time && (
                    <Button
                        size="small"
                        variant="outlined"
                        onClick={() => {
                            calculateDiscount();
                        }}
                    >
                        Calculate Discount Amount
                    </Button>
                )}

                <Button
                    size="small"
                    variant="outlined"
                    onClick={() => {
                        setHouseId(null);
                        setTime(null);
                        setSelectCity(null);
                        setSelectAreaId(null);
                        setSelectArea(null);
                    }}
                >
                    Reset
                </Button>
            </FilterContainer>
        </FilterWrapper>

        <br />

        {/* ── Result ── */}
        {loading ? (
            <CircularLoader />
        ) : discountData ? (
            <ComboDiscountTable discountData={discountData} />
        ) : (
            <EmptyListPlaceholder message="No Data Present" />
        )}
    </WorkspaceContainer>
  )
}

export default ComboDiscountCalculator
